import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn,
} from "@angular/router";
import { AuthService } from "../authentication/services/auth.service";
import { catchError, map, Observable, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class AlreadyLoggedInGuardService {
  private auth = inject(AuthService);
  private router = inject(Router);

  // TODO: Should this be enabled for all /account pages?

  private isLoggedIn$ = this.auth.isLoggedIn$;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.isLoggedIn$.pipe(
      map((isLoggedIn) => {
        if (isLoggedIn) {
          console.log(
            "User is already logged in! Redirecting to profile page..."
          );
          this.router.navigateByUrl("/my-account");
        }
        return !isLoggedIn;
      }),
      catchError(() => {
        this.router.navigateByUrl("/my-account");
        return of(false);
      })
    );
  }
}

export const AlreadyLoggedInGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  return inject(AlreadyLoggedInGuardService).canActivate(next, state);
};
